/**
 * ISSUE-0060 — keep action cards current without WebSockets.
 *
 * Notifications already poll every 30s, but Planning/Calendar fetch once, and
 * background tabs throttle timers. Subscribe to the same interval, skip ticks
 * while hidden, and refetch as soon as the tab is visible again (the Telegram
 * round-trip path).
 */
export const LIVE_REFRESH_MS = 30000;

export function trailingAsync(fn) {
  let inFlight = false;
  let queued = false;
  return async function run() {
    if (inFlight) {
      queued = true;
      return;
    }
    inFlight = true;
    try {
      do {
        queued = false;
        await fn();
      } while (queued);
    } finally {
      inFlight = false;
    }
  };
}

export function subscribeLiveRefresh(run, {
  intervalMs = LIVE_REFRESH_MS,
  immediate = true,
} = {}) {
  const kick = () => {
    if (typeof document !== 'undefined' && document.visibilityState === 'hidden') {
      return;
    }
    run();
  };

  if (immediate) kick();
  const iv = setInterval(kick, intervalMs);

  const onVisible = () => {
    if (typeof document !== 'undefined' && document.visibilityState !== 'visible') {
      return;
    }
    run();
  };

  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', onVisible);
  }
  if (typeof window !== 'undefined') {
    window.addEventListener('focus', onVisible);
  }

  return () => {
    clearInterval(iv);
    if (typeof document !== 'undefined') {
      document.removeEventListener('visibilitychange', onVisible);
    }
    if (typeof window !== 'undefined') {
      window.removeEventListener('focus', onVisible);
    }
  };
}
